const Header = ({ onLogout }) => {
  return (
    <header className="">
      <div className="topbar">
        <div className="container-fluid">
          <div className="navbar-header">
            <div className="d-flex align-items-center gap-2">
              <div className="logo-box">
                <a href="" className="logo-dark">
                  <img src="/assets/images/logo-new.png" className="logo-lg" alt="logo dark" />
                </a>
              </div>
              {/* <div className="topbar-item">
                
              </div> */}

              {/* <!-- Menu --> */}
              <ul className="dropdown topbar-item dropdown-demo">
                <li>
                  <a type="button" className="topbar-button" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Products
                  </a>
                  <div className="dropdown-menu" aria-labelledby="page-header-notifications-dropdown">
                    <div className="row">
                      <div className="col-lg-4">
                        <h6 className="list-heading">Explore our products</h6>
                        <ul className="icon-list">
                          <li>
                            <a href=" ">
                              <i className="ri-bell-fill"></i> ServiceTitan
                            </a>
                          </li>
                          <li>
                            <a href=" ">
                              <i className="ri-building-3-fill"></i> FieldRoutes
                            </a>
                          </li>
                          <li>
                            <a href=" ">
                              <i className="ri-global-fill"></i> Aspire
                            </a>
                          </li>
                          <li>
                            <a href=" ">
                              <i className="ri-bnb-fill"></i> Convex
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="col-lg-4">
                        <h6 className="list-heading">
                          Get more with <span>Pro</span>
                        </h6>
                        <ul>
                          <li>
                            <a href=" ">Marketing Pro</a>
                          </li>
                          <li>
                            <a href=" ">Contact Center Pro</a>
                          </li>
                          <li>
                            <a href=" ">Pricebook Pro</a>
                          </li>
                          <li>
                            <a href=" ">Fleet Pro</a>
                          </li>
                          <li>
                            <a href=" ">Scheduling Pro</a>
                          </li>
                          <li>
                            <a href=" ">Dispatch Pro</a>
                          </li>
                          <li>
                            <a href=" ">Sales Pro</a>
                          </li>
                        </ul>
                      </div>
                      <div className="col-lg-4">
                        <h6 className="list-heading">Pay and Get Paid</h6>
                        <ul>
                          <li>
                            <a href=" ">Payments</a>
                          </li>
                          <li>
                            <a href=" ">Integrated Financing</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <a type="button" className="topbar-button" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Solutions
                  </a>
                  <div className="dropdown-menu dropdown-menu-no-padding" aria-labelledby="page-header-notifications-dropdown">
                    <div className="menu-tab">
                      <ul className="tab-buttons">
                        <div className="tab-indicator">
                          <span className="tab-indicator-inner"></span>
                        </div>
                        <li className="tab-button active" data-tab="tab1">
                          <span>Commercial</span>
                          Power your business with a platform designed to give you workflows that encourage productivity.
                        </li>
                        <li className="tab-button" data-tab="tab2">
                          <span>Residential</span>Empower your team, gain more insights, and impress homeowners at every part of the job cycle.
                        </li>
                      </ul>

                      <div className="tab-content active" id="tab1">
                        <div className="tab-content-inner">
                          <h6>Commercial</h6>
                          <p>Power your business with a platform designed to give you workflows that encourage productivity.</p>
                        </div>
                      </div>
                      <div className="tab-content" id="tab2">
                        <div className="tab-content-inner">
                          <h6>Residential</h6>
                          <p>Empower your team, gain more insights, and impress homeowners at every part of the job cycle.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <a type="button" className="topbar-button" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Resources
                  </a>
                  <div className="dropdown-menu" aria-labelledby="page-header-notifications-dropdown">
                    <div className="row">
                      <div className="col-lg-4">
                        <h6 className="m-0 fs-16 fw-semibold">Notifications</h6>
                        <ul>
                          <li>
                            <a href="">Home demo 1</a>
                          </li>
                          <li>
                            <a href="">Home demo 2</a>
                          </li>
                          <li>
                            <a href="">Home demo 3</a>
                          </li>
                          <li>
                            <a href="">Home demo 4</a>
                          </li>
                          <li>
                            <a href="">Home demo 5</a>
                          </li>
                        </ul>
                      </div>
                      <div className="col-lg-4">
                        <h6 className="m-0 fs-16 fw-semibold">Notifications</h6>
                        <ul>
                          <li>
                            <a href="">Home demo 1</a>
                          </li>
                          <li>
                            <a href="">Home demo 2</a>
                          </li>
                          <li>
                            <a href="">Home demo 3</a>
                          </li>
                          <li>
                            <a href="">Home demo 4</a>
                          </li>
                          <li>
                            <a href="">Home demo 5</a>
                          </li>
                        </ul>
                      </div>
                      <div className="col-lg-4">
                        <h6 className="m-0 fs-16 fw-semibold">Notifications</h6>
                        <ul>
                          <li>
                            <a href="">Home demo 1</a>
                          </li>
                          <li>
                            <a href="">Home demo 2</a>
                          </li>
                          <li>
                            <a href="">Home demo 3</a>
                          </li>
                          <li>
                            <a href="">Home demo 4</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div className="d-flex align-items-center gap-1">
              {/* <form className="app-search d-none d-md-block me-auto">
                <div className="position-relative">
                  <input
                    type="search"
                    className="form-control border-0"
                    placeholder="Search..."
                    autoComplete="off"
                    defaultValue=""
                  />
                  <i className="ri-search-line search-widget-icon"></i>
                </div>
              </form> */}
              {/* <!-- Notification --> */}
              <div className="topbar-item d-none d-md-flex">
                <button type="button" className="topbar-button" id="theme-settings-btn" data-bs-toggle="offcanvas" data-bs-target="#theme-settings-offcanvas" aria-controls="theme-settings-offcanvas">
                  <i className="ri-settings-4-line fs-24"></i>
                </button>
              </div>
              <div className="dropdown topbar-item">
                <button type="button" className="topbar-button position-relative" id="page-header-notifications-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i className="ri-notification-3-line fs-24"></i>
                  <span className="position-absolute topbar-badge fs-10 translate-middle badge bg-danger rounded-pill">
                    3<span className="visually-hidden">unread messages</span>
                  </span>
                </button>
                <div className="dropdown-menu py-0 dropdown-lg dropdown-menu-end" aria-labelledby="page-header-notifications-dropdown">
                  <div className="p-3 border-top-0 border-start-0 border-end-0 border-dashed border">
                    <div className="row align-items-center">
                      <div className="col">
                        <h6 className="m-0 fs-16 fw-semibold"> Notifications</h6>
                      </div>
                      <div className="col-auto">
                        <a href="javascript: void(0);" className="text-dark text-decoration-underline">
                          <small>Clear All</small>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div data-simplebar style={{ maxHeight: "280px" }}>
                    {/* <!-- Item --> */}
                    <a href="javascript:void(0);" className="dropdown-item py-3 border-bottom text-wrap">
                      <div className="d-flex">
                        <div className="flex-shrink-0">
                          <img src="/assets/images/dummy-person.png" className="img-fluid me-2 avatar-sm rounded-circle" alt="avatar-1" />
                        </div>
                        <div className="flex-grow-1">
                          <p className="mb-0">
                            <span className="fw-medium">Josephine Thompson </span>
                            commented on admin panel <span>" Wow 😍! this admin looks good and awesome design"</span>
                          </p>
                        </div>
                      </div>
                    </a>
                    {/* <!-- Item --> */}
                    <a href="javascript:void(0);" className="dropdown-item py-3 border-bottom">
                      <div className="d-flex">
                        <div className="flex-shrink-0">
                          <div className="avatar-sm me-2">
                            <span className="avatar-title bg-soft-info text-info fs-20 rounded-circle">D</span>
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <p className="mb-0 fw-semibold">Donoghue Susan</p>
                          <p className="mb-0 text-wrap">Hi, How are you? What about our next meeting</p>
                        </div>
                      </div>
                    </a>
                    {/* <!-- Item --> */}
                    <a href="javascript:void(0);" className="dropdown-item py-3 border-bottom">
                      <div className="d-flex">
                        <div className="flex-shrink-0">
                          <img src="/assets/images/dummy-person.png" className="img-fluid me-2 avatar-sm rounded-circle" alt="avatar-3" />
                        </div>
                        <div className="flex-grow-1">
                          <p className="mb-0 fw-semibold">Jacob Gines</p>
                          <p className="mb-0 text-wrap">Answered to your comment on the cash flow forecast's graph 🔔.</p>
                        </div>
                      </div>
                    </a>
                    {/* <!-- Item --> */}
                    <a href="javascript:void(0);" className="dropdown-item py-3 border-bottom">
                      <div className="d-flex">
                        <div className="flex-shrink-0">
                          <div className="avatar-sm me-2">
                            <span className="avatar-title bg-soft-warning text-warning fs-20 rounded-circle">
                              <iconify-icon icon="solar:leaf-broken"></iconify-icon>
                            </span>
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <p className="mb-0 fw-semibold text-wrap">
                            You have received <b>20</b> new messages in the conversation
                          </p>
                        </div>
                      </div>
                    </a>
                    {/* <!-- Item --> */}
                    <a href="javascript:void(0);" className="dropdown-item py-3 border-bottom">
                      <div className="d-flex">
                        <div className="flex-shrink-0">
                          <img src="/assets/images/dummy-person.png" className="img-fluid me-2 avatar-sm rounded-circle" alt="avatar-5" />
                        </div>
                        <div className="flex-grow-1">
                          <p className="mb-0 fw-semibold">Shawn Bunch</p>
                          <p className="mb-0 text-wrap">Commented on Admin</p>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="text-center py-3">
                    <a href="javascript:void(0);" className="btn btn-primary btn-sm">
                      View All Notification <i className="ri-arrow-right-line ms-1"></i>
                    </a>
                  </div>
                </div>
              </div>

              {/* <!-- User --> */}
              <div className="dropdown topbar-item">
                <a type="button" className="topbar-button" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <span className="d-flex align-items-center">
                    <img className="rounded-circle" width="32" src="/assets/images/dummy-person.png" alt="avatar-3" />
                  </span>
                </a>
                <div className="dropdown-menu dropdown-menu-end">
                  {/* <!-- item--> */}
                  <h6 className="dropdown-header">Welcome Gaston!</h6>

                  <a className="dropdown-item" href="pages-calendar.html">
                    <iconify-icon icon="solar:calendar-broken" className="align-middle me-2 fs-18"></iconify-icon>
                    <span className="align-middle">My Schedules</span>
                  </a>

                  {/* <a className="dropdown-item" href="index.html">
                    <iconify-icon
                      icon="uil:signin"
                      className="align-middle me-2 fs-18"
                    ></iconify-icon>
                    <span className="align-middle">Sign In</span>
                  </a>
                  <a className="dropdown-item" href="auth-signup.html">
                    <iconify-icon
                      icon="mdi:register-outline"
                      className="align-middle me-2 fs-18"
                    ></iconify-icon>
                    <span className="align-middle">Sign Up</span>
                  </a>
                  <a className="dropdown-item" href="pages-faqs.html">
                    <iconify-icon
                      icon="solar:help-broken"
                      className="align-middle me-2 fs-18"
                    ></iconify-icon>
                    <span className="align-middle">Help</span>
                  </a>
                  <a className="dropdown-item" href="auth-lock-screen.html">
                    <iconify-icon
                      icon="solar:lock-keyhole-broken"
                      className="align-middle me-2 fs-18"
                    ></iconify-icon>
                    <span className="align-middle">Lock screen</span>
                  </a> */}
                  <a className="dropdown-item" href="auth-password.html">
                    <iconify-icon icon="hugeicons:reset-password" className="align-middle me-2 fs-18"></iconify-icon>
                    <span className="align-middle">Reset Password</span>
                  </a>

                  <div className="dropdown-divider my-1"></div>

                  <button type="button" className="dropdown-item text-danger" onClick={onLogout}>
                    <iconify-icon icon="solar:logout-3-broken" className="align-middle me-2 fs-18"></iconify-icon>
                    <span className="align-middle">Logout</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="offcanvas offcanvas-end border-0 rounded-start-4 overflow-hidden" id="theme-settings-offcanvas">
          <div className="d-flex align-items-center bg-primary p-3 offcanvas-header">
            <h5 className="text-white m-0">Theme Settings</h5>
            <button type="button" className="btn-close btn-close-white ms-auto" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>

          <div className="offcanvas-body p-0"></div>
          <div className="offcanvas-footer border-top p-3 text-center">
            <div className="row">
              <div className="col">
                <button type="button" className="btn btn-danger w-100" id="reset-layout">
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
